<template>
  <div>
    <span
      v-for="name in data"
      :key="`aka-${name.name}`"
      class="verifications-components-pep-aka">
      {{ name.name }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'verification-details-pep-info-aka',
  components: {},
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style scoped>
  @import './style.css';
</style>
